<template>
    <ElConfigProvider :locale="elLocale">
        <slot/>
    </ElConfigProvider>
</template>

<script setup lang="ts">
import { ElConfigProvider } from 'element-plus';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getElLocale } from '@/infrastructure/locales/element-plus-locale'

const { locale } = useI18n();

const elLocale = computed(() => {
    return getElLocale(locale.value);
});
</script>
